/**
 * i18n initialization for Dashboard V2
 * Namespace: 'dashboard'
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

let isInitialized = false;

export function initI18n(
  translations: Record<string, string>,
  locale: string
): void {
  if (isInitialized) {
    i18n.changeLanguage(locale);
    i18n.addResourceBundle(locale, 'dashboard', translations, true, true);
    return;
  }

  i18n.use(initReactI18next).init({
    lng: locale,
    fallbackLng: 'en',
    ns: ['dashboard'],
    defaultNS: 'dashboard',
    resources: {
      [locale]: {
        dashboard: translations,
      },
    },
    interpolation: {
      escapeValue: false,
    },
    returnEmptyString: false,
    returnNull: false,
  });

  isInitialized = true;
}

export function t(key: string, params?: Record<string, unknown>): string {
  return i18n.t(key, { ns: 'dashboard', ...(params || {}) });
}

export { i18n };
